// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
export const DEFAULT_STYLE_CLASS = 'jp-DefaultStyle';
//# sourceMappingURL=interface.js.map